"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontLoader = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _core = require("@emotion/core");
var _useIsomorphicLayoutEffect = require("../../hooks/useIsomorphicLayoutEffect");
var _isSSR = require("../../utils/isSSR");
var _FontCSS = require("../FontCSS");
var _utils = require("./utils");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var FontLoader = function FontLoader(_ref) {
  var emberUrl = _ref.emberUrl;
  var _useState = (0, _react.useState)(function () {
      if (_isSSR.isSSR || process.env.NODE_ENV === 'test') return (0, _FontCSS.getFontCSS)(emberUrl);else return '';
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fontCSS = _useState2[0],
    setFontsCSS = _useState2[1];
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    if (!_isSSR.isSSR && process.env.NODE_ENV !== 'test') (0, _utils.getUnloadedFonts)(emberUrl).then(setFontsCSS);
  }, [emberUrl]);
  return (0, _core.jsx)(_core.Global, {
    styles: fontCSS
  });
};
exports.FontLoader = FontLoader;